<template>
  <b-modal id="punch-card-campaign-clear-rewards-modal"
    title="Editing the number of stamps will reset the reward milestones. Do you want to continue?" centered>
    <template slot="modal-footer">
      <b-button variant="outline-secondary" class="mr-2" @click="close">No</b-button>
      <b-button variant="primary" @click="deleteRewards">Yes</b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapFields } from 'vuex-map-fields';

export default {
  computed: {
    ...mapFields("punchCard", ["campaignData"])
  },
  data() {
    return {
      newNumberOfStamps: null
    }
  },
  mounted() {
    this.$root.$on("bv::show::modal", (modalId, stamps) => {
      if (modalId === "punch-card-campaign-clear-rewards-modal") this.newNumberOfStamps = stamps;
    });
  },
  beforeDestroy() {
    this.newNumberOfStamps = null;
  },
  methods: {
    close() {
      this.$root.$emit("bv::hide::modal", "punch-card-campaign-clear-rewards-modal");
      document.body.classList.remove("modal-open");
    },
    deleteRewards() {
      this.campaignData.design.milestones = [];
      this.campaignData.design.number_of_stamps = this.newNumberOfStamps;

      this.$nextTick(() => this.close());
    }
  }
}
</script>

<style lang="scss">
#punch-card-campaign-clear-rewards-modal {
  &>.modal-dialog>.modal-content {
    &>.modal-header {
      &>.modal-title {
        width: 100%;
        font-family: MainFontBold, sans-serif;
        text-align: center;
        margin-top: 2.5rem;
        padding-left: 1.5rem;
        padding-right: 1.5rem;
      }
    }
  }
}
</style>
